export const formatInscricao = (value: string | undefined) => {
  if (!value) {
    return '';
  }

  return value.replace(/[a-zA-Z]/g, '');
};
